import React, {useEffect} from 'react';
import {useAuth, useDarkMode} from "../../../context";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useGetJson, usePostJson} from "../../../hooks";
import {endpoints} from "../../../utils2";
import * as yup from "yup";
import {Alert, Button, Stack} from "react-bootstrap";
import {AdminUserAlert, PageTitle, SelectText, SingleText} from "../../_components";
import {Formik, Form as FormikForm, useFormikContext} from "formik";
import {WhiteCard} from "../_components/WhiteCard";
import onDark from "../icons/case_on_dark.svg"
import offDark from "../icons/case_off_dark.svg"
import impulseDark from "../icons/case_impulse_dark.svg"
import onLight from "../icons/case_on_light.svg"
import offLight from "../icons/case_off_light.svg"
import impulseLight from "../icons/case_impulse_light.svg"
import {RelayAction} from "../../../utils2/maps";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";

export function AddEditRelay({index}) {
    const {authToken} = useAuth()
    const {uid, did, rid} = useParams()
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (rid === "new" && location.state == null) {
            navigate(`/device/${uid}`)
        }
    }, [location, rid])

    const edit = rid !== "new"

    const [ev, loadingEvent, errorEvent, clearErrorEvent] = useGetJson(rid === "new" ? null : endpoints.event.get(rid), authToken?.jwt)
    const event = ev?.data
    const config2 = event?.config2

    const [submitFormAdd, _, loadingAdd, errorAdd, clearErrorAdd] = usePostJson(endpoints.event.add(did), authToken?.jwt)

    const [submitFormEdit, _2, loadingEdit, errorEdit, clearErrorEdit] = usePostJson(endpoints.event.edit(rid), authToken?.jwt)

    const validationSchema = yup.object().shape({
        duration: yup.number().typeError("Duration must be a valid number").required("Duration is required").min(1, "Duration must be at least 1")
            .max(60, "Duration must be at most 60")
            .test("duration-required-for-impulse", "Duration is required for impulse action", function (value) {
                const {action} = this.parent
                if (action === "impulse") {
                    return typeof value === "number" && !isNaN(value);
                }
                return true; // Skip this test if action is not 'impulse'
            })
    })

    const initialValues = {
        // Relay
        // enable: relay?.enable || true,
        action: config2?.action || 1,
        duration: config2?.duration || 5,
        index: index
    }

    function handleOnSubmit(values, action) {
        const payload = {...location.state, name: location.state?.name || event?.name, relay: values}
        if (edit) {
            submitFormEdit(payload, json => {
                action.setSubmitting(false)
                navigate(`/device/${uid}/${did}/config`)
            })
        } else {
            submitFormAdd(payload, jsonTime => {
                action.setSubmitting(false)
                navigate(location.state.steps[2])
            })
        }
    }

    if (edit && loadingEvent) {
        return <div>Loading...</div>;
    }

    // const backTo = -1
    const backTo = () => navigate(location.state?.steps[0], {state: location.state})

    return <Stack>
        <AdminUserAlert/>
        {/*<OurAlert variant="info" show={userId !== uid} msg={`Watch out, you are managing user ID ${uid}.`}/>*/}
        <Alert variant="danger" show={errorEvent} dismissible onClose={clearErrorEvent}>{errorEvent}</Alert>
        <Alert variant="danger" show={errorAdd} dismissible onClose={clearErrorAdd}>{errorAdd}</Alert>
        <Alert variant="danger" show={errorEdit} dismissible onClose={clearErrorEdit}>{errorEdit}</Alert>

        <PageTitle title={`Set Relay ${index}`}>{edit ? `Edit ${event?.name}` : `Add`}.</PageTitle>

        <Formik validationSchema={validationSchema} onSubmit={handleOnSubmit} initialValues={initialValues} enableReinitialize={true}>
            {({isSubmitting, resetForm, values, errors, touched}) => (
                <FormikForm>

                    <RelaySet title={index}/>

                    <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                        {/*<Button as={Link} variant="link" to={backTo}>Go back</Button>*/}
                        <Button variant="link" onClick={backTo}>Go back</Button>
                        <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                        <Button type="submit" variant="primary" disabled={isSubmitting}>{edit ? "Edit" : "Add"}</Button>
                    </Stack>

                </FormikForm>
            )}
        </Formik>

    </Stack>

}

function RelaySet({title}) {
    const {values} = useFormikContext()

    const relayActivation = [
        {id: 0, name: "Disabled", variant: "outline-secondary", disabled: false, icon: "bi bi-ban"},
        {id: 1, name: "Enabled", variant: "success", disabled: false, icon: "bi bi-check2"},
    ]

    const actions = [
        {id: 0, name: RelayAction.find(item => item.id === 0).name, disable: true},
        {id: 1, name: RelayAction.find(item => item.id === 1).name, disable: false},
        {id: 2, name: RelayAction.find(item => item.id === 2).name, disable: false},
    ]
    return <div>
        <WhiteCard>
            <div className="d-flex align-items-center justify-content-between gap-2">
                {/*<div className="fs-6 fw-semibold">{`Relay ${title}`}</div>*/}
                {/*<SingleToggleText name="enable" label="" items={relayActivation}/>*/}
                <SelectText name="action" label="Action" disabled={values?.enable === 0}>
                    {actions.map(item => (
                        <option key={item.id} value={item.id} disabled={item.disable}>{item.name}</option>
                    ))}
                </SelectText>
                {/*{values.action === actions.find(a => a.id === 2)?.name &&*/}
                <ABOverlayTooltip tip="Time interval with Relay On"><span><SingleText name="duration" label="Impulse duration" postfix="sec"
                                                                                      disabled={values.action !== actions.find(a => a.id === 2)?.name}/></span></ABOverlayTooltip>
                {/*}*/}
            </div>
        </WhiteCard>

        <ChartDescription/>

        {/*<SelectText name="controlled_by_id" label="Select relay">*/}
        {/*    <option value="">None</option>*/}
        {/*    {deviceRelay.map((item, index) => (*/}
        {/*        <option key={index} value={index}>{item.name}</option>*/}
        {/*    ))}*/}
        {/*</SelectText>*/}
    </div>
}

function ChartDescription() {
    const {darkMode} = useDarkMode()
    const {values} = useFormikContext()

    if (darkMode) {
        if (values.action === String(RelayAction.find(item => item.id === 1).id)) {
            return <img src={onLight} alt="Relay actions"/>
        } else if (values.action === String(RelayAction.find(item => item.id === 0).id)) {
            return <img src={offLight} alt="Relay actions"/>
        } else if (values.action === String(RelayAction.find(item => item.id === 2).id)) {
            return <img src={impulseLight} alt="Relay actions"/>
        }
    } else {
        if (values.action === String(RelayAction.find(item => item.id === 1).id)) {
            return <img src={onDark} alt="Relay actions"/>
        } else if (values.action === String(RelayAction.find(item => item.id === 0).id)) {
            return <img src={offDark} alt="Relay actions"/>
        } else if (values.action === String(RelayAction.find(item => item.id === 2).id)) {
            return <img src={impulseDark} alt="Relay actions"/>
        }
    }
}